module.exports = __webpack_public_path__ + "img/km_11.ef311b54.jpeg";